import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;
const API_KEEPER = import.meta.env.VITE_API_KEEPER;

const RouteService = {
    list: async (data) => axios.post(API_KEEPER + "/general/route/list", data, {headers: {'Content-Type': 'application/json'}}).then(({data}) => data).catch((err) => { throw err }),
    getList: async () => axios.get(API_KEEPER + "/general/route").then(({data}) => data).catch((err) => { throw err }),
    getById: async (id) => axios.get(`${API_URL}/getRoute/${id}`).then(({data}) => data).catch((err) => { throw err }),
    create: async (data) => axios.post(API_KEEPER + `/general/route/create`, data).then(({data}) => data).catch((err) => { throw err }),
    edit: async (data) => axios.post(API_KEEPER + `/general/route/update`, data).then(({data}) => data).catch((err) => { throw err }),
    destroy: async (id) => axios.delete(API_KEEPER + `/general/route/delete/${id}`).then(({data}) => data).catch((err) => { throw err }),
}

export default RouteService;
